module.exports = __webpack_public_path__ + "img/0S6A9816.de02b807.jpg";